module.exports = __webpack_public_path__ + "static/media/logo-red.3ff75a24.svg";